import t, { Component as e } from "react";
import r from "prop-types";
import n from "react-fast-compare";
import i from "invariant";
import o from "shallowequal";

function a() {
  return a = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
      }
    }

    return t;
  }, a.apply(this, arguments);
}

function s(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, c(t, e);
}

function c(t, e) {
  return c = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  }, c(t, e);
}

function u(t, e) {
  if (null == t) return {};
  var r,
      n,
      i = {},
      o = Object.keys(t);

  for (n = 0; n < o.length; n++) {
    e.indexOf(r = o[n]) >= 0 || (i[r] = t[r]);
  }

  return i;
}

var l = {
  BASE: "base",
  BODY: "body",
  HEAD: "head",
  HTML: "html",
  LINK: "link",
  META: "meta",
  NOSCRIPT: "noscript",
  SCRIPT: "script",
  STYLE: "style",
  TITLE: "title",
  FRAGMENT: "Symbol(react.fragment)"
},
    p = {
  rel: ["amphtml", "canonical", "alternate"]
},
    f = {
  type: ["application/ld+json"]
},
    d = {
  charset: "",
  name: ["robots", "description"],
  property: ["og:type", "og:title", "og:url", "og:image", "og:image:alt", "og:description", "twitter:url", "twitter:title", "twitter:description", "twitter:image", "twitter:image:alt", "twitter:card", "twitter:site"]
},
    h = Object.keys(l).map(function (t) {
  return l[t];
}),
    m = {
  accesskey: "accessKey",
  charset: "charSet",
  class: "className",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  "http-equiv": "httpEquiv",
  itemprop: "itemProp",
  tabindex: "tabIndex"
},
    y = Object.keys(m).reduce(function (t, e) {
  return t[m[e]] = e, t;
}, {}),
    T = function T(t, e) {
  for (var r = t.length - 1; r >= 0; r -= 1) {
    var n = t[r];
    if (Object.prototype.hasOwnProperty.call(n, e)) return n[e];
  }

  return null;
},
    g = function g(t) {
  var e = T(t, l.TITLE),
      r = T(t, "titleTemplate");
  if (Array.isArray(e) && (e = e.join("")), r && e) return r.replace(/%s/g, function () {
    return e;
  });
  var n = T(t, "defaultTitle");
  return e || n || void 0;
},
    b = function b(t) {
  return T(t, "onChangeClientState") || function () {};
},
    v = function v(t, e) {
  return e.filter(function (e) {
    return void 0 !== e[t];
  }).map(function (e) {
    return e[t];
  }).reduce(function (t, e) {
    return a({}, t, e);
  }, {});
},
    A = function A(t, e) {
  return e.filter(function (t) {
    return void 0 !== t[l.BASE];
  }).map(function (t) {
    return t[l.BASE];
  }).reverse().reduce(function (e, r) {
    if (!e.length) for (var n = Object.keys(r), i = 0; i < n.length; i += 1) {
      var o = n[i].toLowerCase();
      if (-1 !== t.indexOf(o) && r[o]) return e.concat(r);
    }
    return e;
  }, []);
},
    C = function C(t, e, r) {
  var n = {};
  return r.filter(function (e) {
    return !!Array.isArray(e[t]) || (void 0 !== e[t] && console && "function" == typeof console.warn && console.warn("Helmet: " + t + ' should be of type "Array". Instead found type "' + typeof e[t] + '"'), !1);
  }).map(function (e) {
    return e[t];
  }).reverse().reduce(function (t, r) {
    var i = {};
    r.filter(function (t) {
      for (var r, o = Object.keys(t), a = 0; a < o.length; a += 1) {
        var s = o[a],
            c = s.toLowerCase();
        -1 === e.indexOf(c) || "rel" === r && "canonical" === t[r].toLowerCase() || "rel" === c && "stylesheet" === t[c].toLowerCase() || (r = c), -1 === e.indexOf(s) || "innerHTML" !== s && "cssText" !== s && "itemprop" !== s || (r = s);
      }

      if (!r || !t[r]) return !1;
      var u = t[r].toLowerCase();
      return n[r] || (n[r] = {}), i[r] || (i[r] = {}), !n[r][u] && (i[r][u] = !0, !0);
    }).reverse().forEach(function (e) {
      return t.push(e);
    });

    for (var o = Object.keys(i), s = 0; s < o.length; s += 1) {
      var c = o[s],
          u = a({}, n[c], i[c]);
      n[c] = u;
    }

    return t;
  }, []).reverse();
},
    O = function O(t, e) {
  if (Array.isArray(t) && t.length) for (var r = 0; r < t.length; r += 1) {
    if (t[r][e]) return !0;
  }
  return !1;
},
    S = function S(t) {
  return Array.isArray(t) ? t.join("") : t;
},
    E = function E(t, e) {
  return Array.isArray(t) ? t.reduce(function (t, r) {
    return function (t, e) {
      for (var r = Object.keys(t), n = 0; n < r.length; n += 1) {
        if (e[r[n]] && e[r[n]].includes(t[r[n]])) return !0;
      }

      return !1;
    }(r, e) ? t.priority.push(r) : t.default.push(r), t;
  }, {
    priority: [],
    default: []
  }) : {
    default: t
  };
},
    I = function I(t, e) {
  var r;
  return a({}, t, ((r = {})[e] = void 0, r));
},
    P = [l.NOSCRIPT, l.SCRIPT, l.STYLE],
    w = function w(t, e) {
  return void 0 === e && (e = !0), !1 === e ? String(t) : String(t).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
},
    x = function x(t) {
  return Object.keys(t).reduce(function (e, r) {
    var n = void 0 !== t[r] ? r + '="' + t[r] + '"' : "" + r;
    return e ? e + " " + n : n;
  }, "");
},
    L = function L(t, e) {
  return void 0 === e && (e = {}), Object.keys(t).reduce(function (e, r) {
    return e[m[r] || r] = t[r], e;
  }, e);
},
    j = function j(e, r) {
  return r.map(function (r, n) {
    var i,
        o = ((i = {
      key: n
    })["data-rh"] = !0, i);
    return Object.keys(r).forEach(function (t) {
      var e = m[t] || t;
      "innerHTML" === e || "cssText" === e ? o.dangerouslySetInnerHTML = {
        __html: r.innerHTML || r.cssText
      } : o[e] = r[t];
    }), t.createElement(e, o);
  });
},
    M = function M(e, r, n) {
  switch (e) {
    case l.TITLE:
      return {
        toComponent: function toComponent() {
          return n = r.titleAttributes, (i = {
            key: e = r.title
          })["data-rh"] = !0, o = L(n, i), [t.createElement(l.TITLE, o, e)];
          var e, n, i, o;
        },
        toString: function toString() {
          return function (t, e, r, n) {
            var i = x(r),
                o = S(e);
            return i ? "<" + t + ' data-rh="true" ' + i + ">" + w(o, n) + "</" + t + ">" : "<" + t + ' data-rh="true">' + w(o, n) + "</" + t + ">";
          }(e, r.title, r.titleAttributes, n);
        }
      };

    case "bodyAttributes":
    case "htmlAttributes":
      return {
        toComponent: function toComponent() {
          return L(r);
        },
        toString: function toString() {
          return x(r);
        }
      };

    default:
      return {
        toComponent: function toComponent() {
          return j(e, r);
        },
        toString: function toString() {
          return function (t, e, r) {
            return e.reduce(function (e, n) {
              var i = Object.keys(n).filter(function (t) {
                return !("innerHTML" === t || "cssText" === t);
              }).reduce(function (t, e) {
                var i = void 0 === n[e] ? e : e + '="' + w(n[e], r) + '"';
                return t ? t + " " + i : i;
              }, ""),
                  o = n.innerHTML || n.cssText || "",
                  a = -1 === P.indexOf(t);
              return e + "<" + t + ' data-rh="true" ' + i + (a ? "/>" : ">" + o + "</" + t + ">");
            }, "");
          }(e, r, n);
        }
      };
  }
},
    k = function k(t) {
  var e = t.baseTag,
      r = t.bodyAttributes,
      n = t.encode,
      i = t.htmlAttributes,
      o = t.noscriptTags,
      a = t.styleTags,
      s = t.title,
      c = void 0 === s ? "" : s,
      u = t.titleAttributes,
      h = t.linkTags,
      m = t.metaTags,
      y = t.scriptTags,
      T = {
    toComponent: function toComponent() {},
    toString: function toString() {
      return "";
    }
  };

  if (t.prioritizeSeoTags) {
    var g = function (t) {
      var e = t.linkTags,
          r = t.scriptTags,
          n = t.encode,
          i = E(t.metaTags, d),
          o = E(e, p),
          a = E(r, f);
      return {
        priorityMethods: {
          toComponent: function toComponent() {
            return [].concat(j(l.META, i.priority), j(l.LINK, o.priority), j(l.SCRIPT, a.priority));
          },
          toString: function toString() {
            return M(l.META, i.priority, n) + " " + M(l.LINK, o.priority, n) + " " + M(l.SCRIPT, a.priority, n);
          }
        },
        metaTags: i.default,
        linkTags: o.default,
        scriptTags: a.default
      };
    }(t);

    T = g.priorityMethods, h = g.linkTags, m = g.metaTags, y = g.scriptTags;
  }

  return {
    priority: T,
    base: M(l.BASE, e, n),
    bodyAttributes: M("bodyAttributes", r, n),
    htmlAttributes: M("htmlAttributes", i, n),
    link: M(l.LINK, h, n),
    meta: M(l.META, m, n),
    noscript: M(l.NOSCRIPT, o, n),
    script: M(l.SCRIPT, y, n),
    style: M(l.STYLE, a, n),
    title: M(l.TITLE, {
      title: c,
      titleAttributes: u
    }, n)
  };
},
    H = [],
    N = function N(t, e) {
  var r = this;
  void 0 === e && (e = "undefined" != typeof document), this.instances = [], this.value = {
    setHelmet: function setHelmet(t) {
      r.context.helmet = t;
    },
    helmetInstances: {
      get: function get() {
        return r.canUseDOM ? H : r.instances;
      },
      add: function add(t) {
        (r.canUseDOM ? H : r.instances).push(t);
      },
      remove: function remove(t) {
        var e = (r.canUseDOM ? H : r.instances).indexOf(t);
        (r.canUseDOM ? H : r.instances).splice(e, 1);
      }
    }
  }, this.context = t, this.canUseDOM = e, e || (t.helmet = k({
    baseTag: [],
    bodyAttributes: {},
    encodeSpecialCharacters: !0,
    htmlAttributes: {},
    linkTags: [],
    metaTags: [],
    noscriptTags: [],
    scriptTags: [],
    styleTags: [],
    title: "",
    titleAttributes: {}
  }));
},
    R = t.createContext({}),
    D = r.shape({
  setHelmet: r.func,
  helmetInstances: r.shape({
    get: r.func,
    add: r.func,
    remove: r.func
  })
}),
    U = "undefined" != typeof document,
    q = /*#__PURE__*/function (e) {
  function r(t) {
    var n;
    return (n = e.call(this, t) || this).helmetData = new N(n.props.context, r.canUseDOM), n;
  }

  return s(r, e), r.prototype.render = function () {
    /*#__PURE__*/
    return t.createElement(R.Provider, {
      value: this.helmetData.value
    }, this.props.children);
  }, r;
}(e);

q.canUseDOM = U, q.propTypes = {
  context: r.shape({
    helmet: r.shape()
  }),
  children: r.node.isRequired
}, q.defaultProps = {
  context: {}
}, q.displayName = "HelmetProvider";

var Y = function Y(t, e) {
  var r,
      n = document.head || document.querySelector(l.HEAD),
      i = n.querySelectorAll(t + "[data-rh]"),
      o = [].slice.call(i),
      a = [];
  return e && e.length && e.forEach(function (e) {
    var n = document.createElement(t);

    for (var i in e) {
      Object.prototype.hasOwnProperty.call(e, i) && ("innerHTML" === i ? n.innerHTML = e.innerHTML : "cssText" === i ? n.styleSheet ? n.styleSheet.cssText = e.cssText : n.appendChild(document.createTextNode(e.cssText)) : n.setAttribute(i, void 0 === e[i] ? "" : e[i]));
    }

    n.setAttribute("data-rh", "true"), o.some(function (t, e) {
      return r = e, n.isEqualNode(t);
    }) ? o.splice(r, 1) : a.push(n);
  }), o.forEach(function (t) {
    return t.parentNode.removeChild(t);
  }), a.forEach(function (t) {
    return n.appendChild(t);
  }), {
    oldTags: o,
    newTags: a
  };
},
    B = function B(t, e) {
  var r = document.getElementsByTagName(t)[0];

  if (r) {
    for (var n = r.getAttribute("data-rh"), i = n ? n.split(",") : [], o = [].concat(i), a = Object.keys(e), s = 0; s < a.length; s += 1) {
      var c = a[s],
          u = e[c] || "";
      r.getAttribute(c) !== u && r.setAttribute(c, u), -1 === i.indexOf(c) && i.push(c);
      var l = o.indexOf(c);
      -1 !== l && o.splice(l, 1);
    }

    for (var p = o.length - 1; p >= 0; p -= 1) {
      r.removeAttribute(o[p]);
    }

    i.length === o.length ? r.removeAttribute("data-rh") : r.getAttribute("data-rh") !== a.join(",") && r.setAttribute("data-rh", a.join(","));
  }
},
    K = function K(t, e) {
  var r = t.baseTag,
      n = t.htmlAttributes,
      i = t.linkTags,
      o = t.metaTags,
      a = t.noscriptTags,
      s = t.onChangeClientState,
      c = t.scriptTags,
      u = t.styleTags,
      p = t.title,
      f = t.titleAttributes;
  B(l.BODY, t.bodyAttributes), B(l.HTML, n), function (t, e) {
    void 0 !== t && document.title !== t && (document.title = S(t)), B(l.TITLE, e);
  }(p, f);
  var d = {
    baseTag: Y(l.BASE, r),
    linkTags: Y(l.LINK, i),
    metaTags: Y(l.META, o),
    noscriptTags: Y(l.NOSCRIPT, a),
    scriptTags: Y(l.SCRIPT, c),
    styleTags: Y(l.STYLE, u)
  },
      h = {},
      m = {};
  Object.keys(d).forEach(function (t) {
    var e = d[t],
        r = e.newTags,
        n = e.oldTags;
    r.length && (h[t] = r), n.length && (m[t] = d[t].oldTags);
  }), e && e(), s(t, h, m);
},
    _ = null,
    z = /*#__PURE__*/function (t) {
  function e() {
    for (var e, r = arguments.length, n = new Array(r), i = 0; i < r; i++) {
      n[i] = arguments[i];
    }

    return (e = t.call.apply(t, [this].concat(n)) || this).rendered = !1, e;
  }

  s(e, t);
  var r = e.prototype;
  return r.shouldComponentUpdate = function (t) {
    return !o(t, this.props);
  }, r.componentDidUpdate = function () {
    this.emitChange();
  }, r.componentWillUnmount = function () {
    this.props.context.helmetInstances.remove(this), this.emitChange();
  }, r.emitChange = function () {
    var t,
        e,
        r = this.props.context,
        n = r.setHelmet,
        i = null,
        o = (t = r.helmetInstances.get().map(function (t) {
      var e = a({}, t.props);
      return delete e.context, e;
    }), {
      baseTag: A(["href"], t),
      bodyAttributes: v("bodyAttributes", t),
      defer: T(t, "defer"),
      encode: T(t, "encodeSpecialCharacters"),
      htmlAttributes: v("htmlAttributes", t),
      linkTags: C(l.LINK, ["rel", "href"], t),
      metaTags: C(l.META, ["name", "charset", "http-equiv", "property", "itemprop"], t),
      noscriptTags: C(l.NOSCRIPT, ["innerHTML"], t),
      onChangeClientState: b(t),
      scriptTags: C(l.SCRIPT, ["src", "innerHTML"], t),
      styleTags: C(l.STYLE, ["cssText"], t),
      title: g(t),
      titleAttributes: v("titleAttributes", t),
      prioritizeSeoTags: O(t, "prioritizeSeoTags")
    });
    q.canUseDOM ? (e = o, _ && cancelAnimationFrame(_), e.defer ? _ = requestAnimationFrame(function () {
      K(e, function () {
        _ = null;
      });
    }) : (K(e), _ = null)) : k && (i = k(o)), n(i);
  }, r.init = function () {
    this.rendered || (this.rendered = !0, this.props.context.helmetInstances.add(this), this.emitChange());
  }, r.render = function () {
    return this.init(), null;
  }, e;
}(e);

z.propTypes = {
  context: D.isRequired
}, z.displayName = "HelmetDispatcher";

var F = ["children"],
    G = ["children"],
    W = /*#__PURE__*/function (e) {
  function r() {
    return e.apply(this, arguments) || this;
  }

  s(r, e);
  var o = r.prototype;
  return o.shouldComponentUpdate = function (t) {
    return !n(I(this.props, "helmetData"), I(t, "helmetData"));
  }, o.mapNestedChildrenToProps = function (t, e) {
    if (!e) return null;

    switch (t.type) {
      case l.SCRIPT:
      case l.NOSCRIPT:
        return {
          innerHTML: e
        };

      case l.STYLE:
        return {
          cssText: e
        };

      default:
        throw new Error("<" + t.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
    }
  }, o.flattenArrayTypeChildren = function (t) {
    var e,
        r = t.child,
        n = t.arrayTypeChildren;
    return a({}, n, ((e = {})[r.type] = [].concat(n[r.type] || [], [a({}, t.newChildProps, this.mapNestedChildrenToProps(r, t.nestedChildren))]), e));
  }, o.mapObjectTypeChildren = function (t) {
    var e,
        r,
        n = t.child,
        i = t.newProps,
        o = t.newChildProps,
        s = t.nestedChildren;

    switch (n.type) {
      case l.TITLE:
        return a({}, i, ((e = {})[n.type] = s, e.titleAttributes = a({}, o), e));

      case l.BODY:
        return a({}, i, {
          bodyAttributes: a({}, o)
        });

      case l.HTML:
        return a({}, i, {
          htmlAttributes: a({}, o)
        });

      default:
        return a({}, i, ((r = {})[n.type] = a({}, o), r));
    }
  }, o.mapArrayTypeChildrenToProps = function (t, e) {
    var r = a({}, e);
    return Object.keys(t).forEach(function (e) {
      var n;
      r = a({}, r, ((n = {})[e] = t[e], n));
    }), r;
  }, o.warnOnInvalidChildren = function (t, e) {
    return i(h.some(function (e) {
      return t.type === e;
    }), "function" == typeof t.type ? "You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information." : "Only elements types " + h.join(", ") + " are allowed. Helmet does not support rendering <" + t.type + "> elements. Refer to our API for more information."), i(!e || "string" == typeof e || Array.isArray(e) && !e.some(function (t) {
      return "string" != typeof t;
    }), "Helmet expects a string as a child of <" + t.type + ">. Did you forget to wrap your children in braces? ( <" + t.type + ">{``}</" + t.type + "> ) Refer to our API for more information."), !0;
  }, o.mapChildrenToProps = function (e, r) {
    var n = this,
        i = {};
    return t.Children.forEach(e, function (t) {
      if (t && t.props) {
        var e = t.props,
            o = e.children,
            a = u(e, F),
            s = Object.keys(a).reduce(function (t, e) {
          return t[y[e] || e] = a[e], t;
        }, {}),
            c = t.type;

        switch ("symbol" == typeof c ? c = c.toString() : n.warnOnInvalidChildren(t, o), c) {
          case l.FRAGMENT:
            r = n.mapChildrenToProps(o, r);
            break;

          case l.LINK:
          case l.META:
          case l.NOSCRIPT:
          case l.SCRIPT:
          case l.STYLE:
            i = n.flattenArrayTypeChildren({
              child: t,
              arrayTypeChildren: i,
              newChildProps: s,
              nestedChildren: o
            });
            break;

          default:
            r = n.mapObjectTypeChildren({
              child: t,
              newProps: r,
              newChildProps: s,
              nestedChildren: o
            });
        }
      }
    }), this.mapArrayTypeChildrenToProps(i, r);
  }, o.render = function () {
    var e = this.props,
        r = e.children,
        n = u(e, G),
        i = a({}, n),
        o = n.helmetData;
    return r && (i = this.mapChildrenToProps(r, i)), !o || o instanceof N || (o = new N(o.context, o.instances)), o ? /*#__PURE__*/t.createElement(z, a({}, i, {
      context: o.value,
      helmetData: void 0
    })) : /*#__PURE__*/t.createElement(R.Consumer, null, function (e) {
      /*#__PURE__*/
      return t.createElement(z, a({}, i, {
        context: e
      }));
    });
  }, r;
}(e);

W.propTypes = {
  base: r.object,
  bodyAttributes: r.object,
  children: r.oneOfType([r.arrayOf(r.node), r.node]),
  defaultTitle: r.string,
  defer: r.bool,
  encodeSpecialCharacters: r.bool,
  htmlAttributes: r.object,
  link: r.arrayOf(r.object),
  meta: r.arrayOf(r.object),
  noscript: r.arrayOf(r.object),
  onChangeClientState: r.func,
  script: r.arrayOf(r.object),
  style: r.arrayOf(r.object),
  title: r.string,
  titleAttributes: r.object,
  titleTemplate: r.string,
  prioritizeSeoTags: r.bool,
  helmetData: r.object
}, W.defaultProps = {
  defer: !0,
  encodeSpecialCharacters: !0,
  prioritizeSeoTags: !1
}, W.displayName = "Helmet";
export { W as Helmet, N as HelmetData, q as HelmetProvider };